import React from 'react'

import { ADDRESS_KEYS } from '@smarty-nx/code-utils'
import { Address } from '@smarty-nx/data'

import classes from './SimpleAddress.module.scss'
import { decodeHtmlEntities } from '../../../utils'
import { Typography } from '../../typography/typography'

interface SimpleAddressProps {
  userAddress: Address | null
}

export const SimpleAddress = ({ userAddress }: SimpleAddressProps) => {
  return (
    <div
      className={classes.simpleAddressWrapper}
      data-testid="simple_user_address"
    >
      {userAddress &&
        ADDRESS_KEYS.map((part) => {
          const value = userAddress[part as keyof Address]
          return (
            value !== null && (
              <Typography
                variant="Montserrat/Medium"
                className="noMargin"
                key={part}
                data-dd-privacy="mask"
              >
                {typeof value === 'string' ? decodeHtmlEntities(value) : value}
              </Typography>
            )
          )
        })}
    </div>
  )
}

export default SimpleAddress
